export const TEST_LIVE_MODE_EVENTS = {
  TOGGLED: "Test Mode Toggled",
  BANNER_VEIWED: "Test Mode Banner Viewed"
};